import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class ConceptPageService extends BaseService {

  async fetch({ lang, conceptMenuId }) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!, $conceptMenuId: CID!) {
            ConceptMenu {
                one (id: $conceptMenuId) {
                    id,
                    text (lang: $lang) {
                        title,
                        meta {
                          title,
                          description
                        },
                    },
                    concepts {
                        id,
                        concept_menu_id,
                        display_order,
                        picture,
                        concept_text (lang: $lang) {
                            id,
                            title,
                            content
                        }
                    }
                }
            }
        }`,
        variables: { lang, conceptMenuId }
      }
    };
    return this._exec(config);
  }

  async fetchSlider({ lang, conceptMenuId }) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'POST',
      data: {
        query: `query ($lang: Lang!, $conceptMenuId: CID!) {
            ConceptMenu {
                one (id: $conceptMenuId) {
                    id,
                    text (lang: $lang) {
                        title
                    },
                    concept_sliders {
                        id,
                        concept_menu_id,
                        display_order,
                        picture,
                        concept_slider_texts (lang: $lang) {
                            id,
                            line1,
                            line2,
                            line3,
                            is_default,
                        }
                    }
                }
            }
       }`,
        variables: { lang, conceptMenuId }
      }
    };
    return this._exec(config);
  }
}

export const conceptPageService = new ConceptPageService();



// WEBPACK FOOTER //
// ./src/network/services/concept-page.service.js